import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../css/GoalCalendar.css";
import Calendar3 from "./Calendar3"; // Assuming Calendar3 is a custom component you have created

const MultiActivityGoalCalendar = () => {
  const userData = JSON.parse(sessionStorage.getItem("user"));
  const userID = userData ? userData.userID : null;
  const [dailyLogs, setDailyLogs] = useState({});
  const [selectedActivity, setSelectedActivity] = useState("workout");
  const [availableActivities, setAvailableActivities] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        "https://18.117.231.157/api/getActivityProgressCalendar",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userID }),
        }
      );

      const result = await res.json();
      console.log("API response:", result);

      if (result.success && Array.isArray(result.data)) {
        const logs = {};
        const uniqueActivities = new Set();

        result.data.forEach((log) => {
          logs[log.date] = log.activities;
          Object.keys(log.activities).forEach((act) =>
            uniqueActivities.add(act)
          );
        });

        setDailyLogs(logs);
        setAvailableActivities(Array.from(uniqueActivities));
        setSelectedActivity((prev) => prev || Array.from(uniqueActivities)[0]);
      }
    };

    fetchData();
  }, [userID]);

  const getTileClassName = ({ date, view }) => {
    if (view !== "month") return null;

    const dateStr = date.toISOString().split("T")[0];
    const activityData = dailyLogs[dateStr]?.[selectedActivity];

    if (!activityData) return null;

    const { value, target } = activityData;
    // const val = selectedActivity === 'walking' ? value / 100 : value;
    const val = value;

    if (val >= target) return "met-goal";
    if (val >= target * 0.75) return "almost-goal";
    return "missed-goal";
  };

  return (
    <div style={{ maxWidth: "420px", marginTop: "1.5rem" }} className="logTile">
      <h2 style={{ textAlign: "center" }}>
        Goal Calendar -{" "}
        {selectedActivity.charAt(0).toUpperCase() + selectedActivity.slice(1)}
      </h2>

      <select
        value={selectedActivity}
        onChange={(e) => setSelectedActivity(e.target.value)}
        style={{ marginBottom: "1rem", padding: "0.5rem", width: "100%" }}
      >
        {availableActivities.map((act) => (
          <option key={act} value={act}>
            {act.charAt(0).toUpperCase() + act.slice(1)}
          </option>
        ))}
      </select>

      <Calendar tileClassName={getTileClassName} />

      <div className="legend">
        <span className="dot met-goal" /> Goal Met
        <span className="dot almost-goal" /> Almost
        <span className="dot missed-goal" /> Missed
      </div>
    </div>
  );
};

export default MultiActivityGoalCalendar;
